import type React from 'react';
import { forwardRef } from 'react';

import { cn } from '@/lib/utils';
import type { TreeItemComponentProps } from './types';

export const TreeItemWrapper = forwardRef<
  HTMLDivElement,
  React.PropsWithChildren<TreeItemComponentProps<object>>
>((props, ref) => {
  const {
    clone,
    depth,
    disableSelection,
    disableInteraction,
    ghost,
    handleProps,
    indentationWidth,
    wrapperRef,
    style,
    className,
    contentClassName,
    children,
  } = props;

  return (
    <li
      ref={wrapperRef}
      className={cn(
        'list-none box-border',
        clone && 'inline-block pointer-events-none',
        ghost && 'opacity-50',
        disableSelection && 'select-none',
        disableInteraction && 'pointer-events-none',
        className,
      )}
      style={{
        ...style,
        paddingLeft: clone ? 0 : indentationWidth * depth,
      }}
    >
      <div
        className={cn('relative flex items-center', contentClassName)}
        ref={ref}
        {...handleProps}
      >
        {children}
      </div>
    </li>
  );
}) as <T>(
  p: React.PropsWithChildren<TreeItemComponentProps<T> & React.RefAttributes<HTMLDivElement>>,
) => React.ReactElement;

(TreeItemWrapper as React.FC).displayName = 'TreeItemWrapper';
